<div class="w-full">
  <audio
    class="w-full"
    controls
    data-testid="podcasts-play-button"
    [appAudioTracking]="trackingConfig"
    [src]="fileURL"
    (endedEvent)="onEnded($event)"
    (pauseEvent)="onPause($event)"
    (playEvent)="onPlay($event)"
    (timeUpdateEvent)="onTimeUpdate($event)"></audio>

  <div class="flex justify-between">
    <button
      class="text-brand-500 w-full uppercase tracking-widest text-link mt-2 hover:underline text-start"
      data-testid="podcasts-share-button"
      (click)="copyShareLink(podcast)">
      share podcast
      @if (!hideLinkArrows) {
        <i class="fas fa-arrow-right ml-1"></i>
      }
    </button>

    <a
      class="text-brand-500 w-full uppercase tracking-widest text-link mt-2 hover:underline"
      target="_blank"
      [href]="pdfURL"
      (click)="onDownloadResearch()">
      download research
      @if (!hideLinkArrows) {
        <i class="fas fa-arrow-right ml-1"></i>
      }
    </a>
  </div>
</div>
